import { useState } from 'react'
import styled from '@emotion/styled'
import ReCAPTCHA from 'react-google-recaptcha'
import { sendResetPassword } from '../redux/actions'
import { useDispatch, useSelector } from 'react-redux'
import { isEmail } from '../lib/strings'
import Button from '../components/Button'
import Input from '../components/Input'

const CaptchaContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
  border-radius: 4px;
  position: relative;
  width: 300px;
  height: 74px;
`

const ForgotPasswordPage = () => {
  const dispatch = useDispatch()
  const loading = useSelector((state) => state.loading)
  const [email, setEmail] = useState('')
  const [robot, setRobot] = useState(
    true && process.env.NODE_ENV !== 'development'
  )

  const handleSubmit = (e) => {
    e.preventDefault()
    dispatch(sendResetPassword({ email }))
  }

  const valid = () => {
    return !robot && isEmail(email)
  }

  return (
    <form onSubmit={handleSubmit}>
      <h3>Forgot password</h3>
      <span>
        Enter your email below and recieve a link to reset your password:
      </span>
      <Input
        autoComplete="email"
        autoFocus
        label="Email"
        name="resetPasswordEmail"
        onChange={(e) => setEmail(e.target.value)}
        required
        value={email}
      />

      <CaptchaContainer className="mb4">
        <ReCAPTCHA
          sitekey="6LeIWtsUAAAAAObzP8nEHBERu6MvH69San5XOMmp"
          onChange={(value) => setRobot(!value)}
        />
      </CaptchaContainer>

      <Button disabled={!valid()} loading={loading} type="submit">
        Send password reset email
      </Button>
    </form>
  )
}

export default ForgotPasswordPage
